import { TrackingPageGuard } from './tracking-page.guard';

export const GUARDS = [TrackingPageGuard];

export { TrackingPageGuard };
